import type IAtlasMergePrepStatusModel from '$provider/lib/apis/interfaces/IAtlasMergePrepStatusModel';
import AtlasMergePrepStatus from '$provider/lib/apis/models/AtlasMergePrepStatus';

export class AtlasMergePrepStatusModel implements IAtlasMergePrepStatusModel {
  status: AtlasMergePrepStatus;
  importId: string | null;

  constructor(status: AtlasMergePrepStatus, importId: string | null) {
    this.status = status;
    this.importId = importId;
  }

  // TODO: From API pass required error and response as parameters
  // Also set the status based on the response
  static fromResponse(
    status: string,
    importId?: string,
    errorCode?: number
  ): AtlasMergePrepStatusModel {
    if (!errorCode) {
      errorCode = 0;
    }
    let statusCode = AtlasMergePrepStatus.Errored;
    if (errorCode === 403) {
      statusCode = AtlasMergePrepStatus.ConnectionError;
    } else {
      switch (status) {
        case AtlasMergePrepStatus.InProgress:
          statusCode = AtlasMergePrepStatus.InProgress;
          break;
        case AtlasMergePrepStatus.Completed:
          statusCode = AtlasMergePrepStatus.Completed;
          break;
        case AtlasMergePrepStatus.Failed:
          statusCode = AtlasMergePrepStatus.Failed;
          break;
      }
    }
    return new AtlasMergePrepStatusModel(statusCode, importId || '');
  }
}
